import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import { getOmniData } from '@src/services/omni-api';
import CommonHeaderStore from '@src/business-components/common-header/store';
import Video from '@src/components/video';
import $$tracker from '@src/tracker';
import { useEffect } from 'react';

let swiperImgRef = null;
let swiperRef = null;
let firstLoad = true;
let firstLoad2 = true;
let stopChange = false;
class AuditionVideoStore extends BaseStore {
  commonHeaderStore = new CommonHeaderStore({
    current: 5,
    changeSwiperCallback: id => {
      this.changeNav(id);
    }
  });
  @observable images = [];
  @observable showFeature = false;
  @observable currentImgIndex = 0;
  @observable currentIndex = 0;
  @observable stop = true;
  @observable stop2 = true;
  @observable changeType = 'default'; // 切换类型
  @observable showSwiper = true;

  @computed
  get params() {
    const that = this;
    return {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 20,
      centeredSlides: true,
      watchSlidesVisibility: true, //防止不可点击
      on: {
        init: function() {
          swiperRef = this;
        },
        slideChangeTransitionStart: function() {
          that.currentIndex = this.realIndex;
        },
        click: function() {
          const visibleSlidesIndexes = this.visibleSlidesIndexes;
          const clickedIndex = this.clickedIndex;
          const foundIndex = visibleSlidesIndexes.findIndex(index => index === clickedIndex);
          if (foundIndex > -1) {
            if (foundIndex < 1) {
              this.slidePrev();
            } else if (foundIndex > 1) {
              this.slideNext();
            }
          }
        }
      }
    };
  }

  // @computed
  // get paramsImg() {
  //   const that = this;
  //   return {
  //     loop: true,
  //     effect: 'fade',
  //     autoplay: {
  //       delay: 5000,
  //       disableOnInteraction: false
  //     },
  //     thumbs: {
  //       swiper: swiperRef
  //     },
  //     on: {
  //       init: function() {
  //         swiperImgRef = this;
  //       }
  //     }
  //   };
  // }

  changeIndex = changeIndex => {
    if (changeIndex === this.currentIndex) {
      return;
    }
    this.currentIndex = changeIndex;
    swiperRef?.slideToLoop(changeIndex);
  };

  openVideo = item => {
    if (!item?.video) {
      return;
    }
    Video.append({ src: item.video });
  };

  getData = async () => {
    try {
      const res = await getOmniData('channel_cat_1beee26b', [
        {
          dataSourceId: 'ds_cat_ec519566' || '',
          page: 1,
          perPage: 99
        }
      ]);
      const data = res.ds_cat_ec519566?.result?.items || [];
      const images = [];
      data.forEach((item, index) => {
        images.push({
          id: index + 1,
          title: item.title || '',
          img: item.video_poster?.[0]?.url || '',
          thumbImg: item.video_thumbnail?.[0]?.url || '',
          video: item.video?.[0]?.url || '',
          title_thumbnail: item.title_thumbnail?.[0]?.url || '',
          title_thumbnail_selected: item.title_thumbnail_selected?.[0]?.url || item.title_thumbnail?.[0]?.url || ''
        });
      });
      this.images = images;
    } catch (error) {
      console.log(error);
    }
  };

  changeNav = id => {
    this.$history.replace(`/?currentPage=${id}`);
  };

  changeSwiper = direction => {
    this.changeType = 'click';
    if (direction === 'prev') {
      swiperRef?.slidePrev();
    } else if (direction === 'next') {
      swiperRef?.slideNext();
    }
  };

  addScrollEvent = () => {
    document.body.addEventListener('scroll', e => {
      // 判断滚动距离大于100
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 100) {
        if (this.commonHeaderStore.isMax) {
          return;
        }
        this.commonHeaderStore.isMax = true;
      } else {
        this.commonHeaderStore.isMax = false;
      }
    });
  };

  goBack = () => {
    this.$history.replace('/?currentPage=5');
  };
  use() {
    super.use();
    useMount(async () => {
      this.addScrollEvent();
      this.getData();
    });

    useEffect(
      () => {
        if (this.images?.[this.currentIndex]) {
          $$tracker.clickStzxChangeVideo(this.images?.[this.currentIndex]?.title);
        }
      },
      [this.currentIndex]
    );

    useEffect(() => {
      // 监听视口变化，节流200ms，变更showSwiper=false,随后为true
      let timer = null;
      const handleResize = () => {
        timer && clearTimeout(timer);
        this.showSwiper = false;
        timer = setTimeout(() => {
          this.showSwiper = true;
          clearTimeout(timer);
        }, 500);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  }
}

export default AuditionVideoStore;
